import {KTIcon} from '../../../../_metronic/helpers'

const ApiPermissionsModalHeader = ({setOpenAPIpermissionsModal}) => {
  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>Edit API Permissions</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() =>  {
          setOpenAPIpermissionsModal(false)
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>

    </div>
  )
}

export {ApiPermissionsModalHeader}
